import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

// Redux type and action creators
const { Types, Creators } = createActions({
  notificationAdded: ['notification'],
  notificationRemoved: [],
  serviceCardChanged: ['service'],
  serviceCardMounted: ['service'],
  reset: []
})

export const NotificationTypes = Types
export default Creators

// Initial state
export const INITIAL_STATE = Immutable({
  notifications: []
})

// Redux reducers
export const notificationAdded = (state, { notification }) => {
  const { notifications } = state
  const nextNotifications = notifications.concat([notification])
  return state.merge({ notifications: nextNotifications })
}

export const notificationRemoved = (state) => {
  const { notifications } = state
  const nextNotifications = [...notifications.slice(0, notifications.length - 1)]

  return state.merge({ notifications: nextNotifications })
}

export const serviceCardChanged = (state, { service={} }) => {
  const { disclaimers } = service

  if (!disclaimers) {
    return state.merge({ notifications: [] })
  }

  return state.merge({ notifications: disclaimers })
}

export const reset = state => {
  return INITIAL_STATE
}

// Assign types to reducers
export const reducer = createReducer(INITIAL_STATE, {
  [Types.NOTIFICATION_ADDED]: notificationAdded,
  [Types.NOTIFICATION_REMOVED]: notificationRemoved,
  [Types.SERVICE_CARD_CHANGED]: serviceCardChanged,
  [Types.SERVICE_CARD_MOUNTED]: serviceCardChanged,
  [Types.RESET]: reset
})



// WEBPACK FOOTER //
// ./src/redux/notificationRedux.js